<template >
	<div class="employeeAutoComplete">
		<!-- :filter="customFilter" -->
	<v-autocomplete 
		v-model="select"
		class="pr-1"
		autocomplete
		autofocus		
		ref="autocomplete"
		:label=label
		:items="items"
		@change="returnSelection"
		clearable
		:prepend-icon="prepend"
		:flat="flat"
		
		hide-no-data
		hide-details		
		:solo-inverted="soloinverted"
		solo
		:outline="outline"
		return-object
		:single-line="singleline"
		:filter="customFilter"
		v-on:change="changeHandler"
	>
		<template slot="item" slot-scope="{ item, tile }">
	        <v-list-tile-avatar dark tile color="grey darken-3" class="smallerAvatar" style="color: white;">
	        	{{item.deptID}}
	        </v-list-tile-avatar>
	        <v-list-tile-content>
		        <v-list-tile-title>
		          	{{item.deptName}}
		        </v-list-tile-title>
		        <v-list-tile-sub-title v-text="`${item.collegeID} ${item.collegeName}`"></v-list-tile-sub-title>
	        </v-list-tile-content>
	    </template>
	    <template slot="selection" slot-scope="{ item, tile }">
	        <v-list-tile-content>
		        <v-list-tile-title>
		          	{{item.deptName}}
		        </v-list-tile-title>
		        <v-list-tile-sub-title v-text="`${item.collegeID} ${item.collegeName}`"></v-list-tile-sub-title>
	        </v-list-tile-content>
	    </template>
	</v-autocomplete>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
	data: () => ({
		loading: false,
		select: null,
	}),

	props: {
    	singleline: Boolean,
    	soloinverted: Boolean,
    	solo: Boolean,
    	outline: Boolean,
    	flat: { type: Boolean, default: true },
    	prepend: String,
    	label: {type: String, default: "Departments" },
    	changeHandler: Function,
    },

    watch: {
		// This was put in to allow routing on RoomViewer.  The roomviewer component sets this sync which is watched.
		async deptSync (val) { 
			this.select = val
		}
	},

    computed: {
		...mapState({ 	items: state => state.lists.depts, 
						deptSync: state => state.roomViewer.deptSync,
		}),
	},

	methods: {
		returnSelection: function (value) {
			this.$emit('return-selection', value)	
		},	

		customFilter (item, queryText, itemText) {
	        const searchText = queryText.toLowerCase()
        	return item.deptID.indexOf(searchText) > -1 	||
          	    item.deptName.toLowerCase().indexOf(searchText) > -1  ||
          	    item.collegeName.toLowerCase().indexOf(searchText) > -1 
	    },
	}
}
</script>

<style>
.v-list__tile--highlighted {
	height: 70px;
}

.smallerAvatar .v-avatar--tile {
	font-size: 10pt !important;
}

</style>




// WEBPACK FOOTER //
// src/components/forms/AutocompleteDepartment.vue